import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormButton, BackButton } from "../components/Buttons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "@reach/router";
import { updateProjectByID, encode } from "../utils/api";
import { StyledClient } from "../styles/StyledClient";
import ErrorPopup from "../components/ErrorPopup";
function EditClient({ location }) {
  const [error, setError] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isSubmitted, setSubmitted] = useState(false);
  const { state } = location;
  const {
    projectID,
    clientName,
    clubName,
    projectName,
    sdl,
    pdl,
    tdl,
    startDate,
    endDate,
  } = state;
  const [startDateState, setStartDateState] = useState(
    startDate ? new Date(startDate) : new Date()
  );
  const [endDateState, setEndDateState] = useState(
    endDate ? new Date(endDate) : new Date()
  );

  useEffect(() => {}, [startDateState, endDateState]);

  const onSubmit = (data) => {
    const { ClientName, ProjectName, SDL, TDL, PDL } = data;
    const body = {
      clubName,
      clientName: ClientName,
      projectName: ProjectName,
      startDate: startDateState,
      endDate: endDateState,
      sdl: SDL,
      pdl: PDL,
      tdl: TDL,
    };
    const encoded = encode(clubName);
    updateProjectByID(encoded, projectID, body)
      .then((res) => {
        if (res) setSubmitted(true);
      })
      .catch((err) => {
        if (err) setError(err);
      });
  };
  return (
    <StyledClient>
      <h1>Edit project</h1>
      {error && <ErrorPopup errors={error.response.data.errors} />}
      <form onSubmit={handleSubmit(onSubmit)}>
        <label htmlFor="ClientName">Client Name</label>
        <input
          required={true}
          {...register("ClientName")}
          placeholder="Client Name"
          defaultValue={clientName}
        />
        <label htmlFor="ProjectName">Project Name</label>
        <input
          required={true}
          {...register("ProjectName")}
          placeholder="Project Name"
          defaultValue={projectName}
        />{" "}
        <label>Start Date</label>
        <DatePicker
          selected={startDateState}
          dateFormat="dd/MM/yyyy"
          required={true}
          onChange={(date) => setStartDateState(date)}
        />
        <label>End Date</label>
        <DatePicker
          selected={endDateState}
          dateFormat="dd/MM/yyyy"
          required={true}
          onChange={(date) => setEndDateState(date)}
        />
        <label htmlFor="SDL">Service Delivery Lead</label>
        <input
          {...register("SDL")}
          placeholder="Service Delivery Lead"
          defaultValue={sdl}
        />
        <label htmlFor="TDL">Technical Delivery Lead</label>
        <input
          {...register("TDL")}
          placeholder="Technical Delivery Lead"
          defaultValue={tdl}
        />
        <label htmlFor="PDL">Product Delivery Lead</label>
        <input
          aria-invalid={errors.name ? "true" : "false"}
          {...register("PDL")}
          placeholder="Product Delivery Lead"
          defaultValue={pdl}
        />
        <FormButton disabled={isSubmitted} right="209px" value="Save project" />
        {isSubmitted && (
          <p style={{ color: "#2797fe", fontSize: "0.8rem" }}>
            Project successfully saved
          </p>
        )}
      </form>

      <Link
        state={{
          id: projectID,
          projectName,
          clubName,
          clientName,
        }}
        to={`/project/${projectID}`}
      >
        <BackButton />
      </Link>
    </StyledClient>
  );
}

export default EditClient;
